
















import {Component, Prop, Vue} from 'vue-property-decorator';
import HotkeyListener from '@/layouts/gripper/hotkeys/HotkeyListener.vue';

@Component({
  components: {HotkeyListener},
})
export default class PaginateButtonsShrinkingBin extends Vue {

  @Prop({default: true}) public canChangePage?: boolean;
  @Prop(Number) public currentPage!: number;
  @Prop(Number) public totalPages!: number;

  public pageChange(origin: KeyboardEvent['key'] | string | number) {
      this.$emit('onPageChangeEvent', origin);
  }
}
